import { Component, OnInit } from '@angular/core';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';

@Component({
  selector: 'app-job-legend-nav',
  templateUrl: './job-legend-nav.component.html',
  styleUrls: ['./job-legend-nav.component.scss'],
})
export class JobLegendNavComponent implements OnInit {
  constructor(
    private jobPointeService: JobPointeService,
    private toastService: ToastService,
  ) {}

  employeeTypes: any;
  tags: Array<any> = [];

  ngOnInit(): void {
    this.getEmployeeTypes();
    this.getTags();
  }

  getTags() {
    this.jobPointeService.read['jobBoardTags']({}).subscribe(res => {
      this.tags = res.data;
    });
  }

  getEmployeeTypes() {
    this.jobPointeService.read['employeeTypes']({}).subscribe(res => {
      this.employeeTypes = res.data;
    });
  }

  deleteTag(tag) {
    this.jobPointeService.delete['jobBoardTag']({ id: tag.id }).subscribe(res => {
      if (res.success) {
        this.toastService.showToast(res.message, 'success');
        this.getTags();
      } else {
        this.toastService.showToast(res.error.message, 'error');
      }
    });
  }
}
